import React from 'react';
import TaskWorkspace from '../../components/TwoDays/TaskWorkspace';

/** 팀 전체 태스크 — 보기 탭 Timeline(기본) · By progress · By assignee */
export const TwoDaysAllTasks = () => <TaskWorkspace scope='all' />;

/** 내 태스크 — 보기 탭 Assigned to me(기본) · To review. 받는 사람으로서 할 일(승인·반려)은 To review 에서 */
export const TwoDaysMyTasks = () => <TaskWorkspace scope='mine' />;
